<stream-donation-component *ngFor="let donation of donations" [model]="donation">
</stream-donation-component>